import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";
import Alert from "@components/Alert";

import StoreCard from "@components/Stores/StoreCard";

const StoresMapNoSSR = dynamic(() => import("./StoresMap"), { ssr: false });

const StoreCards = ({ stores }) => {
  // Display store cards if we have stores
  if (stores && stores.length > 0) {
    return (
      <div className="mb-12">
        <div className="lg:mb-6">
          <StoresMapNoSSR markers={stores} />
        </div>

        <ul className="flex flex-wrap m-0 lg:-ml-20 -ml-6 p-0 leading-20">
          {stores.map((store) => (
            <li
              key={store.id}
              className="w-full sm:w-1/2 md:w-1/3 pl-6 lg:pl-20 mt-6"
            >
              <StoreCard store={store} />
            </li>
          ))}
        </ul>
      </div>
    );
  }

  // Fallback, no stores
  return (
    <div className="mb-6">
      <Alert type="info" showIcon>
        Nu au fost gasite magazine
      </Alert>
    </div>
  );
};

StoreCards.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      distance: PropTypes.number,
      image: PropTypes.string,
      url_key: PropTypes.string.isRequired,
    }).isRequired
  ),
};

export default StoreCards;
